import * as React from "react"

const NameComponent = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1440"
      height="415"
      className={"nameComponent"}
    >
      <defs>
        <pattern
          id="water"
          width=".25"
          height="1.1"
          patternContentUnits="objectBoundingBox"
        >
          <path
            fill={props.textColor}
            d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"
          />
        </pattern>

        <text
          id="text"
          x="10"
          transform="matrix(1 0 0 1 -8.0684 116.7852)"
          font-family="Helvetica Neue"
          color={props.textColor}
          font-size="228"
          font-weight="700"
        >
          ADDISON
        </text>

        <mask id="text_mask">
          <use x="0" y="0" xlinkHref="#text" opacity="1" fill={props.bgColor} />
        </mask>
      </defs>
      <rect
        className="water-fill"
        mask="url(#text_mask)"
        fill="url(#water)"
        x="-400"
        y="0"
        width="1600"
        height="120"
      />
    </svg>
  )
}

NameComponent.defaultProps = {
  width: 1044,
  height: 125,
}

export default NameComponent
